/**
 * Visual metadata for CRM timeline (icons + avatars)
 */

import { timelineAuthorInitial } from './crm-display.js'

/** @typedef {'staff' | 'client' | 'system'} TimelineActorKind */

/**
 * @param {object} event
 * @param {{ leadDisplayName?: string | null }} [ctx]
 */
export function getTimelineActor(event, ctx = {}) {
  const { event_type: type, created_by_name: staffName, payload } = event
  const leadName = ctx.leadDisplayName?.trim() || null

  if (type === 'client_message') {
    return {
      kind: 'client',
      label: leadName || 'Client',
      initial: timelineAuthorInitial(leadName || 'Client'),
    }
  }

  if (type === 'call' && payload?.direction === 'inbound') {
    return {
      kind: 'client',
      label: leadName || 'Client',
      initial: timelineAuthorInitial(leadName || 'Client'),
    }
  }

  if (
    staffName &&
    ['note', 'status_change', 'assignment', 'call', 'lead_created', 'message_sent', 'marketing_consent', 'assignee_nudge', 'sp_migrated'].includes(type)
  ) {
    return {
      kind: 'staff',
      label: staffName,
      initial: timelineAuthorInitial(staffName),
    }
  }

  if (type === 'form_submitted' && payload?.manual && staffName) {
    return {
      kind: 'staff',
      label: staffName,
      initial: timelineAuthorInitial(staffName),
    }
  }

  return { kind: 'system', label: 'Automated', initial: null }
}

export function getTimelineIconId(event) {
  const { event_type: type } = event
  const map = {
    lead_created: 'user-plus',
    note: 'message-square',
    status_change: 'git-branch',
    form_submitted: 'file-text',
    assignment: 'user-check',
    call: 'phone',
    sp_migrated: 'arrow-right',
    idle_alert: 'bell',
    client_followup: 'send',
    client_message: 'message-circle',
    marketing_consent: 'check-circle',
    assignee_nudge: 'bell-ring',
    dedup_conflict: 'alert-triangle',
    message_sent: 'mail',
  }
  return map[type] || 'activity'
}
